// Based on the gist from stewartknapman that can be found here https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c, Cheers Mate

export class Money {
  money_format = "£{{amount}}";
  money_with_currency_format = "£{{amount}} GBP";

  constructor() {
    const $jsonMoney = document.querySelector(".json-money");

    if ($jsonMoney) {
      const moneyData = JSON.parse($jsonMoney.textContent);
      this.money_format = moneyData?.money_format;
      this.money_with_currency_format = moneyData?.money_with_currency_format;
    }
  }

  formatMoney = (cents, format) => {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || this.money_format;

    const defaultOption = (opt, def) => {
      return typeof opt == "undefined" ? def : opt;
    };

    const formatWithDelimiters = (number, precision, thousands, decimal) => {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    };

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

export default Money;
